import { render } from "./DividerLine.vue?vue&type=template&id=ed0122d4"
import script from "./DividerLine.vue?vue&type=script&lang=js"
export * from "./DividerLine.vue?vue&type=script&lang=js"

import "./DividerLine.vue?vue&type=style&index=0&id=ed0122d4&lang=scss"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__